/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Error_Name_RequiredInputs */

const vi_customer_error_name_required = /** @type {(inputs: Customer_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên khách hàng`)
};

/**

* @param {Customer_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_error_name_required = /** @type {((inputs?: Customer_Error_Name_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Error_Name_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_error_name_required(inputs)
});